import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { saveSample } from "../../actions";
 
const syncOrgSamples = (dispatch) => {
  const request = indexedDB.open("DNA_Pathogen_Tracker", 1);
  request.onsuccess = (event) => {
    const db = event.target.result;
    const txn = db.transaction('org_sample', "readwrite");
    const objectStore = txn.objectStore('org_sample');

    objectStore.openCursor().onsuccess = (event) => {
        let cursor = event.target.result;
        if (cursor) {
          console.log(cursor)
            let orgSample = cursor.value;
            dispatch(saveSample(orgSample))
            objectStore.delete(cursor.key)
            // continue next record
            cursor.continue();
        }
    };
    // close the database connection
    txn.oncomplete = function () {
        db.close();
    };
  };

}

const useNetworkStatus = () => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(navigator.onLine);
  
  useEffect(() => {
    const setOnline = () => {
      setStatus(true);
      syncOrgSamples(dispatch);
      window.location.reload();
    };

    const setOffline = () => {
      setStatus(false);
      
    };

    window.addEventListener("online", setOnline);
    window.addEventListener("offline", setOffline);

    return () => {
      window.removeEventListener("online", setOnline);
      window.removeEventListener("offline", setOffline);
    };
  }, []);

  return status;
};

export default useNetworkStatus;


